import { USER_ROLES } from "@nlc/shared-types";

import { useRoleAccess } from "@/features/auth/permissions/useRoleAccess";

import { ProjectInfoPopup } from "./account-information";
import { InternalNotesWidget } from "./internal-notes";

export function StickyWidget({
  openInternalNotes,
  projectId,
  requestId,
}: {
  openInternalNotes?: boolean;
  projectId?: number;
  requestId?: number;
}) {
  const { hasRole } = useRoleAccess();
  const showInfos = hasRole([
    USER_ROLES.DESIGNER,
    USER_ROLES.SUPER_ADMIN,
    USER_ROLES.TEAM_LEADER,
    USER_ROLES.CUSTOMER_SUCCESS,
  ]);

  if (!showInfos) return;

  return (
    <>
      <ProjectInfoPopup projectId={projectId} />
      <InternalNotesWidget
        initialOpen={openInternalNotes}
        projectId={projectId}
        requestId={requestId}
      />
    </>
  );
}
